import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BackendService } from '../../core/backend.service';
import { InternalNodeInputMapping } from '../../viewmodels/internal-node-input-mapping';

@Injectable()
export class InternalNodeMappingService {

  private _modelId: string;

  private mappingList = new Array<string>();

  internalMappings = new BehaviorSubject(new Array<string>());

  set modelId(value: string) {
    this._modelId = value;
    this.refreshInternalMappings();
  };

  get modelId(): string {
    return this._modelId;
  }

  refreshInternalMappings() {
    this.mappingList = new Array<string>();
    this.backendService.getById<InternalNodeInputMapping>(InternalNodeInputMapping, this.modelId)
      .subscribe(mappings => {
        if (mappings) {
          mappings.nodes.forEach(n => {
            // add inputs
            mappings.inputs.forEach(ni => {
              if (ni.nodeId === n.nodeId) {
                this.mappingList.push(n.nodeName + '.' + ni.identifier);
              }
            });
            // add outputs
            mappings.outputs.forEach(no => {
              if (no.nodeId === n.nodeId) {
                this.mappingList.push(n.nodeName + '.' + no.identifier);
              }
            });
          });

          this.internalMappings.next(this.mappingList);
        }
      });
  }

  constructor(private backendService: BackendService) { }
}
